import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Typography,
  Button,
  Paper,
  Divider,
  OutlinedInput,
  Checkbox,
  ListItemText
} from "@mui/material";
import "./Addpopup.css";

const SelectItems = ["Casting Director", "Producer"];
const ActorSelectItems = ["Actor", "Actress"];

const CrewSelectItems = [
  "Director",
  "1st Assistant Director",
  "2nd Assistant Director",
  "Line Producer",
  "Production Manager",
  "Production Coordinator",
  "Production Secretary",
  "Production Assistant",
  "Script Supervisor",
  "Stunt Coordinator",
  "Story Producer",
  "Location Manager",
  "Location Assistant",
  "Location Scout",
  "Director of Photography",
  "Camera Operator",
  "First Assistant Camera",
  "Second Assistant Camera",
  "Camera Production Assistant",
  "Digital Imaging Technician",
  "Data Wrangler",
  "Steadicam Operator",
  "Production Sound Mixer",
  "Boom Operator",
  "Key Grip",
  "Best Boy (Grip)",
  "Dolly Grip",
  "Gaffer",
  "Best Boy (Electrical)",
  "Lighting Technician",
  "Production Designer",
  "Art Director",
  "Set Designer",
  "Set Decorator",
  "Buyer",
  "Set Dresser",
  "Props Master",
  "Standby Props",
  "Props Builder",
  "Make-up Artist",
  "SFX Make-up Artist",
  "Hairdresser",
  "Costume Designer",
  "Costume Supervisor",
  "Cutter/Fitter",
  "Film Editor",
  "Assistant Editor",
  "Online Editor",
  "Colourist",
  "Negative Cutter",
  "Best Boy",
  "Camera Assistant",
  "Caterer",
  "Cinematographer",
  "Costume Coordinator",
  "COVID Compliance Officer",
  "Crafts and Services",
  "Driver",
  "Electrician",
  "Generator Operator",
  "Grip",
  "Hair Stylist",
  "Intimacy Coordinator",
  "Key PA",
  "Lead Man",
  "Makeup Artist",
  "Officer PA",
  "On Set Editor",
  "Production Accountant",
  "Production Assistance",
  "Prop Master",
  "Prosthetics Designer",
  "Screenwriter",
  "Set Medic",
  "Set PA",
  "SFX Coordinator",
  "SFX Editor",
  "SFX Makeup Artist",
  "SFX Supervisor",
  "Shopper",
  "Sound Mixer",
  "Stunt Choreographer",
  "Stunt Performer",
  "Tailor",
  "Transportation Coordinator",
  "Unit Production Manager",
  "Video Assist Operator",
  "Weapons Wrangler"
];



const CategoryPopup = ({
  title,
  options,
  initialSelection = [], // Changed to array
  onAdd,
  onClose,
  role,
  label,
}) => {
  // Ensure selection state is always initialized as an array
  const [selection, setSelection] = useState(Array.isArray(initialSelection) ? initialSelection : [initialSelection].filter(Boolean));
  const [isValid, setIsValid] = useState(false);
  const [selectOptions, setSelectOptions] = useState([
    "Casting Director",
    "Producer",
  ]);
  const isMultiSelect = role === "crew";

  useEffect(() => {
    if (role === "crew") {
      setSelectOptions(CrewSelectItems);
    } else if (role === "actor") {
      setSelectOptions(ActorSelectItems);
    } else {
      setSelectOptions(SelectItems);
    }
  }, [role]);

  // Removed this useEffect as useState now handles initial array conversion
  // useEffect(() => {
  //   setSelection(Array.isArray(initialSelection) ? initialSelection : [initialSelection].filter(Boolean));
  // }, [initialSelection]);

  useEffect(() => {
    if (selection && selection.length > 0) { // Check if array has items
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [selection]);

  const handleSubmit = () => {
    if (typeof onAdd === "function") {
      onAdd(isMultiSelect ? selection : selection[0] || "");
      onClose();
    } else {
      console.error("onAdd is not a function");
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    if (isMultiSelect) {
      setSelection(
        typeof value === 'string' ? value.split(',') : value,
      );
      return;
    }

    setSelection([value]);
  };

  return (
    <div className="edit-popup">
      <div className="edit-popup-content">
        <div className="edit-popup-header">
          <h2>{title}</h2>
        </div>
        <div className="edit-popup-body">
          <div className="edit-popup-field">
            <label>{label || "Category"}</label>
            {/* Using Material-UI Select for multiple selections */}
            <FormControl fullWidth variant="filled">
              <InputLabel id="multiple-job-titles-label">Job Titles</InputLabel>
              <Select
                labelId="multiple-job-titles-label"
                id="multiple-job-titles-checkbox"
                multiple={isMultiSelect}
                value={isMultiSelect ? selection : selection[0] || ""}
                onChange={handleChange}
                input={<OutlinedInput label="Job Titles" />}
                renderValue={(selected) => (Array.isArray(selected) ? selected.join(', ') : selected)}
                MenuProps={{
                  disableScrollLock: true,
                }}
              >
                {selectOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {isMultiSelect ? (
                      <>
                        <Checkbox checked={selection.indexOf(option) > -1} />
                        <ListItemText primary={option} />
                      </>
                    ) : (
                      <ListItemText primary={option} />
                    )}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        {/* <div className="edit-popup-field"> */}
        <div className="edit-popup-footer">
          {isValid && <button onClick={handleSubmit}>Save</button>}
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

CategoryPopup.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  initialSelection: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  onAdd: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};

export default CategoryPopup;
